import React from 'react'

/**
 * Anonymous home page component
 * @type {React.FunctionComponent}
 */
function Home () {
  return (
    <div className="home" />
  )
}

Home.propTypes = {
}

export default Home
